export const PSYCHE_CLASS_YEAR = '2026';
export const PSYCHE_CLASS_NAME = 'Gold Class';
